import React from 'react';
/**
 * @ignore - internal component.
 */
export const RadioGroupContext = /*#__PURE__*/React.createContext(null);